var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotateRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#858282",
    d: "M9.76667 2.17702C8.80001 1.21035 7.47334 0.610352 6.00001 0.610352C3.05334 0.610352 0.67334 2.99702 0.67334 5.94368C0.67334 8.89035 3.05334 11.277 6.00001 11.277C8.48667 11.277 10.56 9.57702 11.1533 7.27702H9.76667C9.22001 8.83035 7.74001 9.94368 6.00001 9.94368C3.79334 9.94368 2.00001 8.15035 2.00001 5.94368C2.00001 3.73702 3.79334 1.94368 6.00001 1.94368C7.10667 1.94368 8.09334 2.40368 8.81334 3.13035L6.66667 5.27702H11.3333V0.610352L9.76667 2.17702Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateRight);
export default __webpack_public_path__ + "static/media/rotate-right.3280c95843b7aa513b33687498758b71.svg";
export { ForwardRef as ReactComponent };